import React from "react";

import Form          from 'react-bootstrap/Form';
import Row           from 'react-bootstrap/Row';
import Col           from 'react-bootstrap/Col';
import FloatingLabel from 'react-bootstrap/FloatingLabel';

const Etapa2 = ( props ) => {
  
  return (
    <Row>
      <Col md={{ span: 6, offset: 3 }} className="zzbox">
 
        <Row>
          <Col md={6} >
            <FloatingLabel
              controlId = "cnpj"
              label     = "CNPJ *">
              <Form.Control type        = "text" 
                            placeholder = "."
                            value       = {props.values.cnpj} 
                            onChange    = {props.handleChange} 
                            onBlur      = {props.handleChange} 
                            name        = "cnpj"/>
            </FloatingLabel>
          </Col>
          <Col md={6}>
            <FloatingLabel
              controlId = "func"
              label     = "Qtd. Funcionários">
              <Form.Control type        = "text" 
                            placeholder = "."
                            value       = {props.values.func} 
                            onChange    = {props.handleChange} 
                            name        = "func"/>
            </FloatingLabel>
          </Col>

        </Row>

        <br/>

        <Row>
          <Col>
            <FloatingLabel
              controlId = "empresa"
              label     = "Nome da Empresa *">
              <Form.Control type        = "text" 
                            placeholder = "."
                            value       = {props.values.empresa} 
                            onChange    = {props.handleChange} 
                            onBlur      = {props.handleChange} 
                            name        = "empresa"/>
            </FloatingLabel>
          </Col>
        </Row>

        <br/>

        <Row>
          <Col>
            <FloatingLabel
              controlId = "ramo"
              label     = "Ramo">
              <Form.Control type        = "text" 
                            placeholder = "."
                            value       = {props.values.ramo} 
                            onChange    = {props.handleChange} 
                            name        = "ramo"/>
            </FloatingLabel>
          </Col>
        </Row>

        <br/>

        <Row>
          <Col md={3}>
            <FloatingLabel
              controlId = "cep"
              label     = "CEP *">
              <Form.Control type        = "text" 
                            placeholder = "."
                            value       = {props.values.cep} 
                            onChange    = {props.handleChange} 
                            onBlur      = {props.handleChange} 
                            name        = "cep"/>
            </FloatingLabel>
          </Col>
          <Col md={9}>
            <FloatingLabel
              controlId = "bairro"
              label     = "Bairro">
              <Form.Control type        = "text" 
                            placeholder = "."
                            value       = {props.values.bairro} 
                            onChange    = {props.handleChange} 
                            name        = "bairro"/>
            </FloatingLabel>
          </Col>
        </Row>

        <br/>

        <Row>
          <Col>
            <FloatingLabel
              controlId = "endereco"
              label     = "Endereço">
              <Form.Control type        = "text" 
                            placeholder = "."
                            value       = {props.values.endereco} 
                            onChange    = {props.handleChange} 
                            name        = "endereco"/>
            </FloatingLabel>
          </Col>
        </Row>

        <br/>

        <Row>
          <Col md={10}>
            <FloatingLabel
              controlId = "cidade"
              label     = "Cidade">
              <Form.Control type        = "text" 
                            placeholder = "."
                            value       = {props.values.cidade} 
                            onChange    = {props.handleChange} 
                            name        = "cidade"/>
            </FloatingLabel>
          </Col>
          <Col md={2}>
            <FloatingLabel
              controlId = "estado"
              label     = "Estado">
              <Form.Control type        = "text" 
                            placeholder = "."
                            value       = {props.values.estado} 
                            onChange    = {props.handleChange} 
                            name        = "estado"/>
            </FloatingLabel>
          </Col>
        </Row>

    </Col>
  </Row>
  );
}
export default Etapa2;